"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EyebrowType;
(function (EyebrowType) {
    EyebrowType["DefaultNatural"] = "DefaultNatural";
    EyebrowType["RaisedExcitedNatural"] = "RaisedExcitedNatural";
    EyebrowType["AngryNatural"] = "AngryNatural";
    EyebrowType["SadConcernedNatural"] = "SadConcernedNatural";
    EyebrowType["UpDownNatural"] = "UpDownNatural";
    EyebrowType["FlatNatural"] = "FlatNatural";
    EyebrowType["UnibrowNatural"] = "UnibrowNatural";
    EyebrowType["Default"] = "Default";
    EyebrowType["RaisedExcited"] = "RaisedExcited";
    EyebrowType["Angry"] = "Angry";
    EyebrowType["SadConcerned"] = "SadConcerned";
    EyebrowType["UpDown"] = "UpDown";
})(EyebrowType || (EyebrowType = {}));
exports.default = EyebrowType;
